<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  /**
   * Total number of skeleton columns to render.
   */
  columnsCount?: number;
  /**
   * Indexes (0-based) of columns that should use circle skeletons.
   */
  circleColumns?: number[];
  /**
   * How many skeleton rows to render.
   */
  rowsCount?: number;
}

const props = withDefaults(defineProps<Props>(), {
  columnsCount: 8,
  circleColumns: () => [0],
  rowsCount: 5,
});

const columnIndexes = computed(() => Array.from({ length: props.columnsCount }, (_, i) => i));
</script>

<template>
  <div class="ui-table-skeleton">
    <Skeleton height="2rem" class="ui-table-skeleton__header" />
    <DataTable :value="new Array(rowsCount)">
      <Column
        v-for="index in columnIndexes"
        :key="index"
        :style="circleColumns.includes(index) ? 'width: 3rem' : undefined"
      >
        <template #body>
          <Skeleton v-if="circleColumns.includes(index)" shape="circle" size="1.5rem" />
          <Skeleton v-else />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<style scoped lang="scss">
.ui-table-skeleton {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.ui-table-skeleton__header {
  margin-bottom: 1rem;
}
</style>
